import React from 'react';
import PropTypes from 'prop-types';

const ImageOverlay = ({light, opacity, style}) => {
    const overlayColor = light ? `rgba(255,255,255,${opacity ? opacity : .5}` : `rgba(0,0,0,${opacity ? opacity : .5}`
    return (
        <div style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, backgroundColor: overlayColor, ...style}}/>
    );
};

ImageOverlay.propTypes = {
    
};

export default ImageOverlay;